import Button from '@zenbusiness/zui/Button';
import { superstyled } from '@zenbusiness/zui/styles';

export const ChatActionButton = superstyled({
  tag: Button,
  name: 'ChatAction',
  slot: 'ChatActionButton',
  styles: {
    justifyContent: 'start',
  },
});
